module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbList",
    on: {
      "click": function($event) {
        return _vm.handleDetial(_vm.data.liveId)
      }
    }
  }, [_c('img', {
    staticClass: "zbList-img",
    attrs: {
      "src": _vm.data.backgroundUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbList-box"
  }, [_c('div', {
    staticClass: "zbList-box-fl-box"
  }, [_c('div', {
    staticClass: "zbList-box-fl"
  }, [_vm._v(_vm._s(_vm.data.categoryName))])]), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "zbList-box-zbjl"
  }, [_c('div', {
    staticClass: "zbList-box-zbjl-top"
  }, [_c('span', {
    staticClass: "zbList-box-zbjl-left-span"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.isOpenReplay == 1 && _vm.data.replayUrl) ? _c('div', {
    staticClass: "zbList-box-zbjl-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePlayVideo(_vm.data.replayUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/huifang@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.huifang')))])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "zbList-box-zbjl-left-span1"
  }, [_vm._v(_vm._s(_vm.data.liveStartTime) + "-" + _vm._s(_vm.data.liveEndTime))])]) : _c('div', {
    staticClass: "zbList-box-title"
  }, [_c('div', {
    staticClass: "zbList-box-title-left"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "zbList-box-title-right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/zhibo_shutiao_16@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.onlineUserCount))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241a2e81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zbList/zbList.vue
// module id = 801
// module chunks = 1